export default "__VITE_ASSET__854d98ac__"